function headerScrollHandler() {
  if (window.pageYOffset > 20) {
    document.body.classList.add('header-scrolling');
  } else {
    document.body.classList.remove('header-scrolling');
  }

  if (window.pageYOffset > 150) {
    document.body.classList.add('header-scrolling-v2');
  } else {
    document.body.classList.remove('header-scrolling-v2');
  }
}

window.addEventListener('scroll', headerScrollHandler);
document.addEventListener('DOMContentLoaded', headerScrollHandler);

const header = document.querySelector('.header--root');
const mainContent = document.querySelector('main#main_content');

if(window.stickyHeader && document.body.classList.contains('template--index')) {
  function layoutPaddingHandler() {
    // mainContent.style.paddingTop = `${header.offsetHeight}px`;
  }

  document.addEventListener('DOMContentLoaded', layoutPaddingHandler);
  window.addEventListener('load', layoutPaddingHandler);
  window.addEventListener('resize', layoutPaddingHandler);
  window.addEventListener('orientationchange', layoutPaddingHandler);
}